import { createSlice, PayloadAction } from '@reduxjs/toolkit'
//import { ValidationErrors } from 'types/app'

import { 
  getAllNotifications, 
  markNotificationAsRead,
  clearAllNotifications,
  markAllNotificationsAsRead 
} from './actions'
import { State } from './types'

const initialState: State = {
  isLoading: false,
  isCreateNotification: false,
  isGettingDetails: false,
  notifaction: {
    _id: '',
    user_id: '',
    text: '',
    link: '',
    isRead: false,
  },
  notifactions: [],
  error: null,
  unReadNotifications: 0,
}

const notificationSlice = createSlice({
  name: 'team',
  initialState,
  reducers: {
    updateNotifications(state, action: any) {
      const notification = action.payload.notification
      //  add this notification to the top of the list
      state.notifactions = [notification, ...state.notifactions]
      //  increment the unread notification count
      if (notification.isRead === false) {
        state.unReadNotifications += 1
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllNotifications.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(getAllNotifications.fulfilled, (state, { payload }: any) => {
        state.isLoading = false
        // console.log('payload', payload)

        state.notifactions = payload.data || payload.notifications
        state.unReadNotifications = payload.unreadCount || payload.count
      })
      .addCase(getAllNotifications.rejected, (state, action) => {
        state.isLoading = false
        if (action.payload) {
          state.error = action.payload.errors
        } else {
          state.error = action.error.message
        }
      })
      .addCase(markNotificationAsRead.pending, (state) => {
        state.isGettingDetails = true
        state.error = null
      })
      .addCase(markNotificationAsRead.fulfilled, (state, { payload }: any) => {
        state.isGettingDetails = false
        const index = state.notifactions.findIndex(
          (notification) => notification._id === payload.notification._id,
        )
        // console.log(payload, 'payload')

        if (index !== -1) {
          state.notifactions[index] = payload.notification
        }
        state.unReadNotifications = payload.count
      })

      // .addCase(markNotificationAsRead.fulfilled, (state, { payload }) => {
      //   state.isGettingDetails = false
      //   state.notifaction = payload
      //   const index = state.notifactions.findIndex(
      //     (notification) => notification._id === payload._id,
      //   )
      //   state.notifactions[index] = payload
      //   if (payload.isRead === false) {
      //     state.unReadNotifications -= 1
      //   }
      // })
      .addCase(markNotificationAsRead.rejected, (state, action) => {
        state.isGettingDetails = false
        if (action.payload) {
          state.error = action.payload.errors || action.payload.message
        } else {
          state.error = action.error.message
        }
      })
      .addCase(clearAllNotifications.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(clearAllNotifications.fulfilled, (state) => {
        state.isLoading = false
        state.notifactions = []
        state.unReadNotifications = 0
      })
      .addCase(clearAllNotifications.rejected, (state, action) => {
        state.isLoading = false
        if (action.payload) {
          state.error = action.payload.errors || action.payload.message
        } else {
          state.error = action.error.message
        }
      })
      .addCase(markAllNotificationsAsRead.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(markAllNotificationsAsRead.fulfilled, (state, { payload }: any) => {
        state.isLoading = false
        state.notifactions = payload.notifications
        state.unReadNotifications = payload.count
      })
      .addCase(markAllNotificationsAsRead.rejected, (state, action) => {
        state.isLoading = false
        if (action.payload) {
          state.error = action.payload.errors || action.payload.message
        } else {
          state.error = action.error.message
        }
      })
  },
})

export const { reducer, actions } = notificationSlice
export const { updateNotifications } = notificationSlice.actions

export default notificationSlice
